import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import Select from 'react-select';
import { reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { saveRequirement, updateRequirement, exportCSV } from "../../Services/GeometryUserService";
import { db } from '../../db';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      displayColorPicker: false,

      substancias: [],
      selectedSub: '',
      selectOptionsSub: [],
      
      selectedUso: '',
      selectOptionsUso: [],

      data: {
        id: '',
				name: '',
				type: '',
				user: '',
				cidade: null,
				estado: null,
				substancia: null,
				substanciaUso: null,
				description: '',
				cidadeDivisa: '',
				color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
        updatedAt: '',
        syncAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(this.validateEntries()){

      let rgb = JSON.stringify(data['colorRGB']);
      data['colorRGB'] = rgb;

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        dataUserGeometryList: []
      };
      request.dataUserGeometryList.push(data);
  
      if(data.id === undefined || data.id === null || data.id === ''){
        saveRequirement(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              db.remove(data.name, "REQUERIMENTO");
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });

      }else{
        updateRequirement(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              db.remove(data.name, "REQUERIMENTO");
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  handleExport(e){
    const data = { ...this.state.data }
    exportCSV(data.id)
    .then(obj => {
        const url = window.URL.createObjectURL(new Blob([obj]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data.name + '.csv'); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;
   
    if(data.name === undefined || data.name === null || data.name === ''){
      this.show('danger', this.props.t('forms.requiredFieldName'));
      validated = false;
    }

    if(data.substancia === undefined || data.substancia === null || 
      data.substancia.id === undefined || data.substancia.id === null || data.substancia.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldSubs'));
      validated = false;
    }

    if(data.substanciaUso === undefined || data.substanciaUso === null || 
      data.substanciaUso.id === undefined || data.substanciaUso.id === null || data.substanciaUso.id === 0){
      this.show('danger', this.props.t('forms.requiredFieldSubsUso'));
      validated = false;
    }

    return validated;  
  }

  loadData(selected, substancias) {
    let options = [];

    options = [];
    if(substancias !== undefined && substancias !== null && substancias.length > 0 && this.state.substancias.length === 0){
      for(let i = 0; i < substancias.length; i++){
        options.push({value:substancias[i].id, label: substancias[i].name});
      }
      this.setState({ 
        selectOptionsSub: options, 
        substancias: substancias 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {
        if(selected.id === null){
          selected.id = '';
        }
        if(selected.user === null){
          selected.user = '';
        }
        if(selected.description === null){
          selected.description = '';
        }
        if(selected.cidadeDivisa === null){
          selected.cidadeDivisa = '';
        }
        
        let selectedSub = '';
        let selectOptionsUso = [];
        if(selected.substancia !== undefined && selected.substancia !== null && selected.substancia.id !== null){
          selectedSub = {value:selected.substancia.id, label: selected.substancia.name};

          for(let i = 0; i < substancias.length; i++){
            if(substancias[i].id === selected.substancia.id){
              for(let j = 0; j < substancias[i].substanciasUso.length; j++){
                selectOptionsUso.push({value:substancias[i].substanciasUso[j].id, label: substancias[i].substanciasUso[j].name});
              }
            }
          }
        }

        let selectedUso = '';
        if(selected.substanciaUso !== undefined && selected.substanciaUso !== null && selected.substanciaUso.id !== null){
          selectedUso = {value:selected.substanciaUso.id, label: selected.substanciaUso.name};
        }        

        this.setState({ 
          data: selected, selectedSub, selectOptionsUso, selectedUso
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, substancias } = this.props;
    this.loadData(selected, substancias);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected|| props.substancias !== this.props.substancias){
      this.loadData(this.props.selected, this.props.substancias);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateFaseSub(event) {
    const data = { ...this.state.data }

    let selectedSub = '';
    let selectOptionsUso = [];
    let selectedUso = '';
    data["substancia"] = '';
    data["substanciaUso"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        selectOptionsUso = [];
        for(let i = 0; i < this.state.selectOptionsSub.length; i++){
          if(this.state.selectOptionsSub[i].value === event[j].value){
            selectedSub = event[j];
            
            for(let e = 0; e < this.state.substancias.length; e++){
              if(this.state.substancias[e].id === selectedSub.value){
                data["substancia"] = this.state.substancias[e];

                for(let s = 0; s < this.state.substancias[e].substanciasUso.length; s++){
                  selectOptionsUso.push({value:this.state.substancias[e].substanciasUso[s].id, label: this.state.substancias[e].substanciasUso[s].name});
                }
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedSub, selectOptionsUso, selectedUso });
  }

  updateFaseUso(event) {
    const data = { ...this.state.data }

    let selectedUso = '';
    data["substanciaUso"] = '';
    if(event !== null){
      for(let j = 0; j < event.length; j++){
        for(let i = 0; i < this.state.selectOptionsUso.length; i++){
          if(this.state.selectOptionsUso[i].value === event[j].value){
            selectedUso = event[j];
            
            for(let e = 0; e < this.state.substancias.length; e++){
              if(this.state.substancias[e].id === this.state.data.substancia.id){
                for(let s = 0; s < this.state.substancias[e].substanciasUso.length; s++){
                  if(this.state.substancias[e].substanciasUso[s].id === selectedUso.value){
                    data["substanciaUso"] = this.state.substancias[e].substanciasUso[s];
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({ data, selectedUso });
  }


  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['type'] = '';
    data['user'] = '';
    data['cidade'] = null;
    data['estado'] = null;
    data['substancia'] = null;
    data['substanciaUso'] = null;
    data['description'] = '';
    data['cidadeDivisa'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    data['syncAt'] = '';

    this.setState({ 
      data,
      active: false,
      displayColorPicker: false
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const data = { ...this.state.data }
    data['color'] = color.hex;
    data['colorRGB'] = color.rgb;
    this.setState({ data });
  };

  render() {
    const { t } = this.props;
    const { data, active, displayColorPicker } = this.state;
    const color = data.color;
    const rgb = data.colorRGB;
    
    let notOK = !hasAccess("MENU_MY_REQUIREMENT_SAVE");
    let exportNotOK = !hasAccess("MENU_MY_REQUIREMENT_EXPORT");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let cidades = [];
    let cidadeList = this.state.data.cidadeDivisa.substring(0,this.state.data.cidadeDivisa.lastIndexOf(";")).split(";");
    for(let i = 0; i < cidadeList.length; i++){
      cidades.push(<div key={"cidade_"+i}>{cidadeList[i]}</div>);
    }
    let isDivisa = false;
    if(cidades.length > 1){
      isDivisa = true;
    }
    

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.name')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="name"
                      value={this.state.data.name}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.substancia')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="substancia"
                        value={this.state.selectedSub}
                        onChange={e => this.updateFaseSub(e)}
                        options={this.state.selectOptionsSub}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        required
                      />
                  </div>

                  <div className="form__form-group">
                    <span className="form__form-group-label" style={{marginTop: '10px'}}>
                      {t('forms.localizacao')} <i style={{color: '#ff0000', fontSize: '11px'}}>{(isDivisa ? t('forms.localizacaoDivisa') : '')} </i> 
                    </span>
                    <div className="form__form-group-field" 
                      style={{borderLeft: '2px solid #ffd9d9', minHeinght: '25px', height: 'auto', 
                              display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px',
                              marginLeft: '5px', fontStyle: 'italic', color: '#ff0000'}}>
                      {cidades}

                    </div>
                  </div>
                </div>
              </div>


              <div className="form__half">
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.color')} 
                  </span>
                  <div className="form__form-group-field">
                    <div className="color-picker">
                      <button
                        type="button"
                        className={`color-picker__button${active ? ' active' : ''}`}
                        onClick={this.handleClick}
                        id="color"
                      >
                        <p className="color-picker__color">{color}</p>
                        <div className="color-picker__color-view" style={{ backgroundColor: color }} />
                      </button>
                      <Popover
                        isOpen={displayColorPicker}
                        target="color"
                        placement="bottom"
                        className="color-picker__popover"
                      >
                        <SketchPicker
                          color={rgb}
                          onChange={e => this.handleChange(e)}
                        />
                      </Popover>
                    </div>                    
                  </div>
                </div>

                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.substanciaUso')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <Select
                        isMulti = "true"
                        maxMenuHeight="150px"
                        name="substanciaUso"
                        value={this.state.selectedUso}
                        onChange={e => this.updateFaseUso(e)}
                        options={this.state.selectOptionsUso}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                        required
                      />
                  </div>
                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button color="primary" type="button" disabled={exportNotOK}
                  onClick={e => this.handleExport(e)}>
                  {t('forms.export')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'requerimentoEdit', 
})(withTranslation('common')(CrudEdit));
